import { render, staticRenderFns } from "./BetaTests.vue?vue&type=template&id=73b3dde7&"
import script from "./BetaTests.vue?vue&type=script&lang=js&"
export * from "./BetaTests.vue?vue&type=script&lang=js&"
import style0 from "./BetaTests.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports